/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
	
  //Media Center Filters
  var currentURL = window.location.protocol  + '//' + window.location.hostname + window.location.pathname;
	
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('select').customSelect();
		  

        //nav

        $('.cd-primary-nav-trigger').click(function() {
          $('.search-nav').removeClass('search-active');
          $('.search-nav').toggleClass('menu-active');
          $('.cd-primary-nav-trigger').toggleClass('is-clicked');
          $('html, body').animate({
            scrollTop: 0
          }, 800);
        });

        $('.mobile-search').click(function() {
          $('.search-nav').removeClass('menu-active');
          $('.cd-primary-nav-trigger').removeClass('is-clicked');
          $('.search-nav').toggleClass('search-active');
        });

        /* ---------------------------------------------------------------------- */
        /*	Scroll to top + menu smooth scroll
        /*	updated to change the top target
        /* ---------------------------------------------------------------------- */


        $(window).scroll(function(){
          if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
          } else {
            $('.scrollup').fadeOut();
          }
        }); 

        $('.scrollup').click(function(){
          $("html, body").animate({ scrollTop: 0 }, 700);
          return false;
        });		
        //console.log('scroll');

        $('.scrollup').fadeOut();
		  
		  
		  
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }, 
    // Contact page, note the change from about-us to about_us.
    'page_template_template_media_center': {
      init: function() {
        //Contact Offices Filter
        var mediaParams = '';
        var tagParams = '';
        var serviceAreaParams = '';

        $(document).on('change', '.filter-row select#media-type-select', function(e) {
         //$('.filter-row input[type="checkbox"]:checked').each(function() {
            // mediaParams = mediaParams + $(this).val() + '|';
         //});
           mediaParams = '';
           $('.filter-row select#media-type-select').each(function() {
             mediaParams = mediaParams + $(this).val() + '|';
         });
           //console.log(mediaParams);
          $('#media-center-list').load(currentURL +'?ptypes=' + mediaParams + '&sarea=' + serviceAreaParams + '&tags=' + tagParams + ' #media-center-inner', function() {
            //console.log(window.location.protocol  + '//' + window.location.hostname + window.location.pathname);
            //console.log(testParams);
          });
        });
        $(document).on('change', '.filter-row select#service-area-select', function(e) {
           serviceAreaParams = '';
           $('.filter-row select#service-area-select').each(function() {
             serviceAreaParams = serviceAreaParams + $(this).val();
         });
           //console.log(serviceAreaParams);
          $('#media-center-list').load(currentURL +'?ptypes=' + mediaParams + '&sarea=' + serviceAreaParams + '&tags=' + tagParams + ' #media-center-inner', function() {
            //console.log(window.location.protocol  + '//' + window.location.hostname + window.location.pathname);
            //console.log(testParams);
          });
        });
        $(document).on('change', '.filter-row select#tags-select', function(e) {
          tagParams = '';
          $('.filter-row select#tags-select').each(function() {
            tagParams = tagParams + $(this).val();
          });
          //console.log(tagParams);
          $('#media-center-list').load(currentURL +'?ptypes=' + mediaParams + '&sarea=' + serviceAreaParams + '&tags=' + tagParams + ' #media-center-inner', function() {
            //console.log(window.location.protocol  + '//' + window.location.hostname + window.location.pathname);
            //console.log(testParams);
          });
        });
      }
    },
    // Blog filter
    'page_template_template_blog': {
      init: function() {
        //Contact Offices Filter
        var mediaParams = '';
        var tagParams = '';
        var serviceAreaParams = '';
        var targetURL = '';
        
        //Contact Offices Filter
        console.log('page_template_template_blog');
        var serviceAreaParams = '';
        $(document).on('change', '.filter-row input', function(e) {
           serviceAreaParams = $(this).val();
          /* $('.filter-row input').each(function() {
             
           });*/
           //console.log(serviceAreaParams);
          targetURL = currentURL +'?sarea=' + serviceAreaParams + '&tags=' + tagParams + ' #media-center-inner';
          $('#media-center-list').load(targetURL, function() {
            //console.log(window.location.protocol  + '//' + window.location.hostname + window.location.pathname);
            console.log(targetURL);
          });
        });
        $('.filter-row input').on('change', function(e) {
          
           serviceAreaParams =  $(this).val();
           console.log(serviceAreaParams);
           //console.log(serviceAreaParams);
            /*$(window).load(window.location.protocol  + '//' + window.location.hostname + window.location.pathname + serviceAreaParams, function() {
              console.log(window.location.protocol  + '//' + window.location.hostname + window.location.pathname);
              console.log(serviceAreaParams);
            });*/
          });
        }
    },
    // Contact page, note the change from about-us to about_us.
    'page_template_template_contact': {
      init: function() {
        //Contact Offices Filter
        $(document).on('change', 'select#office-state-select', function(e) {
          console.log('on change');
          var filterState = $(this).val();

          $('#locations-list').load(currentURL +'?state=' + filterState + ' #locations-inner', function() {
            //console.log(window.location.protocol  + '//' + window.location.hostname + window.location.pathname);
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
